const normalizeHex = (hex: string): string => {
  let h = hex.trim().replace(/^#/, '').toLowerCase();
  if (h.length === 3) {
    h = h
      .split('')
      .map((c: string) => c + c)
      .join('');
  }
  return h;
};

const hexToRgb = (hex: string): number[] => {
  const h = normalizeHex(hex);
  return [0, 2, 4].map((i: number) => parseInt(h.substring(i, i + 2), 16));
};

const rgbToHex = (rgb: number[]): string =>
  `#${rgb.map((v: number) => v.toString(16).padStart(2, '0')).join('')}`;

export const relativeLuminance = (hex: string): number => {
  const [r, g, b] = hexToRgb(hex).map((v: number) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const contrastRatio = (hexA: string, hexB: string): number => {
  const la = relativeLuminance(hexA);
  const lb = relativeLuminance(hexB);
  const [light, dark] = la >= lb ? [la, lb] : [lb, la];

  return (light + 0.05) / (dark + 0.05);
};

export const accessibleTextColorOn = (bgHex: string): string =>
  contrastRatio('#ffffff', bgHex) >= contrastRatio('#333333', bgHex)
    ? '#ffffff'
    : '#333333';

export const darkenToContrast = (
  hex: string,
  againstHex: string,
  minRatio: number
): string => {
  let rgb = hexToRgb(hex);

  for (let i = 0; i < 50; i++) {
    if (contrastRatio(rgbToHex(rgb), againstHex) >= minRatio) {
      return i === 0 ? `#${normalizeHex(hex)}` : rgbToHex(rgb);
    }
    rgb = rgb.map((v: number) => Math.max(0, Math.floor(v * 0.92)));
  }

  return '#000000';
};
